/**
 * Qué corresponde a qué en la búsqueda global.
 *
 * Vive aparte de la pantalla porque son dos reglas que se pueden afirmar sin
 * montar nada, y porque una de las dos ya se rompió una vez sin que nadie lo
 * notara: la pestaña acotaba **la consulta** y no **lo que se dibuja**, así que
 * con los datos de «Todo» ya en caché, elegir «Sub áreas» seguía enseñando
 * personas y solicitudes. La pestaña parecía un filtro y era un interruptor de
 * red.
 */

/** Sin acentos y en minúsculas, para que «Iñiguez» encuentre a «iniguez». */
export const normalise = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

/**
 * Si alguno de los textos del resultado contiene lo buscado.
 *
 * Recibe los campos del propio resultado, y ahí está la regla que importa: un
 * feriado se encuentra por lo que dice el feriado, no porque una solicitud que
 * sí coincide caiga en esos días. Cruzar tipos llenaría cada pestaña de cosas
 * que no contienen lo que se escribió.
 */
export const matchesAny = (needle: string, ...fields: readonly (string | null)[]): boolean => {
  if (needle.length === 0) return false;
  return fields.some((field) => field !== null && normalise(field).includes(needle));
};

/**
 * Si un grupo de resultados le toca a la pestaña activa.
 *
 * «Todo» no es un tipo de resultado, es la ausencia de filtro; el resto se
 * llaman igual que su grupo. Se aplica al dibujar y no sólo al consultar,
 * porque los datos de una consulta anterior siguen en la caché y volverían a
 * salir.
 */
export const showsGroup = (scope: string, group: string): boolean =>
  scope === 'Todo' || scope === group;
